import React from 'react';
import { ApolloProvider as ApolloProvider$1 } from '@apollo/client';
import { ApolloContext } from './ApolloContext.mjs';

function ApolloProvider({
  client,
  children
}) {
  const providerValue = React.useMemo(() => ({
    client,
    operations: client.__operations_cache__
  }), [client]);
  return /*#__PURE__*/React.createElement(ApolloProvider$1, {
    client: client
  }, /*#__PURE__*/React.createElement(ApolloContext.Provider, {
    value: providerValue
  }, children));
}

export { ApolloProvider };
